/* The Hollow Harvest · gli effetti di superficie
   Separati da hh.js di proposito: se qualcosa qui va storto, il sito resta
   completo e leggibile. Ogni effetto si spegne con prefers-reduced-motion. */

(function () {
  'use strict';

  /* Una funzione non è un effetto. Chi ha chiesto meno animazioni deve
     comunque poter aprire le tavole: qui si spegne il movimento, non il sito. */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(hover: none)').matches;

  /* ------------------------------------------------ velina di apertura ---- */
  /* Un foglio di carta che si alza la prima volta che si apre la pagina.
     Dura poco, non blocca niente, e se il JS fallisce non compare affatto. */
  function initCurtain() {
    if (reduce) return;
    var curtain = document.createElement('div');
    curtain.className = 'hh-curtain';
    curtain.setAttribute('aria-hidden', 'true');
    document.body.appendChild(curtain);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        curtain.classList.add('is-up');
        setTimeout(function () { curtain.remove(); }, 1400);
      });
    });
  }

  /* --------------------------------------------------- titoli a parole ---- */
  /* I titoli di sezione salgono una parola alla volta, come righe composte a
     mano. Si applica solo agli h2: sugli h1 c'è già la maschera. */
  function initSplitTitles() {
    if (reduce) return;
    var titles = document.querySelectorAll('.hh-section h2');
    if (!titles.length || !('IntersectionObserver' in window)) return;

    titles.forEach(function (h) {
      if (h.querySelector('.hh-word')) return;
      var words = h.textContent.trim().split(/\s+/);
      if (words.length > 24) return;
      h.textContent = '';
      words.forEach(function (w, i) {
        var outer = document.createElement('span');
        outer.className = 'hh-word';
        var inner = document.createElement('span');
        inner.textContent = w;
        inner.style.transitionDelay = Math.min(i * 45, 500) + 'ms';
        outer.appendChild(inner);
        h.appendChild(outer);
        if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-set');
        io.unobserve(e.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });

    titles.forEach(function (h) { io.observe(h); });
    // garanzia dura: passati tre secondi nessun titolo può restare invisibile
    setTimeout(function () { titles.forEach(function (h) { h.classList.add('is-set'); }); }, 3000);
    // rete di sicurezza: nessun titolo resta mai invisibile
    window.addEventListener('load', function () {
      setTimeout(function () {
        titles.forEach(function (h) {
          if (h.getBoundingClientRect().top < window.innerHeight) h.classList.add('is-set');
        });
      }, 1400);
    });
  }

  /* ------------------------------------------- traccia legata allo scroll -- */
  /* Le tacche non si segnano tutte insieme: si incidono man mano che la
     sezione scorre, così il conteggio sale mentre leggi. */
  function initTrackScroll() {
    var track = document.querySelector('.hh-track');
    if (!track) return;
    if (reduce) {
      // senza movimento le tacche ci sono comunque, tutte incise
      track.querySelectorAll('.hh-track__step').forEach(function (s) { s.classList.add('is-cut'); });
      return;
    }
    var steps = track.querySelectorAll('.hh-track__step');
    if (!steps.length) return;

    function update() {
      var r = track.getBoundingClientRect();
      var vh = window.innerHeight;
      // da 0 quando la traccia entra dal basso, a 1 quando è a due terzi dello schermo
      var p = (vh * 0.9 - r.top) / (vh * 0.55 + r.height * 0.4);
      p = Math.max(0, Math.min(1, p));
      var lit = Math.round(p * steps.length);
      for (var i = 0; i < steps.length; i++) {
        steps[i].classList.toggle('is-cut', i < lit);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* --------------------------------------------------------- lightbox ---- */
  /* Le tavole sono il prodotto: si devono poter guardare grandi.
     Chiusura con Esc, con un clic fuori, o con il bottone. */
  function initLightbox() {
    var plates = document.querySelectorAll('.hh-showcase .hh-plate, .hh-look__img');
    if (!plates.length) return;

    var box = document.createElement('div');
    box.className = 'hh-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.hidden = true;
    box.innerHTML =
      '<button class="hh-lightbox__close" type="button" aria-label="Close">&#215;</button>' +
      '<figure class="hh-lightbox__figure"><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(box);

    var img = box.querySelector('img');
    var cap = box.querySelector('figcaption');
    var last = null;

    function open(src, alt, caption, source) {
      last = source;
      img.src = src;
      img.alt = alt || '';
      cap.textContent = caption || '';
      cap.hidden = !caption;
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      box.querySelector('.hh-lightbox__close').focus();
    }

    function close() {
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { box.hidden = true; if (last) last.focus(); }, 240);
    }

    plates.forEach(function (el) {
      var fig = el.closest('figure');
      var caption = fig && fig.querySelector('figcaption') ? fig.querySelector('figcaption').textContent.trim() : '';
      el.style.cursor = 'zoom-in';
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', 'Open the plate' + (caption ? ': ' + caption : ''));
      el.addEventListener('click', function () { open(el.currentSrc || el.src, el.alt, caption, el); });
      el.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); open(el.currentSrc || el.src, el.alt, caption, el); }
      });
    });

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('hh-lightbox__close')) close();
    });

    /* La tastiera non deve poter uscire dalla finestra aperta: chi naviga con
       il tabulatore resterebbe a girare dietro il fondo scuro. */
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var focusables = box.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var lastEl = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });

    /* Sulle battlemap serve guardare da vicino: un clic sull'immagine aperta la
       ingrandisce e la si trascina. Un altro clic torna a vederla intera. */
    /* L'ingrandimento si scrive in `transform`, non nelle proprieta' singole
       `scale` e `translate`: WebKit qui non le applica, la classe arrivava e
       l'immagine restava della stessa misura. Misurato il 2026-09-21: su
       Chromium 374 -> 748 pixel, su WebKit 374 -> 374 con `is-zoomed` presente
       e `scale` computato a 1. */
    var zoomed = false, ox = 0, oy = 0;
    function disegna() {
      img.style.transform = zoomed
        ? 'translate(' + ox + 'px, ' + oy + 'px) scale(2)'
        : '';
    }
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      zoomed = !zoomed;
      if (!zoomed) { ox = 0; oy = 0; }
      img.classList.toggle('is-zoomed', zoomed);
      img.style.transformOrigin = '50% 50%';
      img.style.cursor = zoomed ? 'grab' : 'zoom-in';
      disegna();
    });
    var dragging = false, sx = 0, sy = 0;
    img.addEventListener('pointerdown', function (e) {
      if (!zoomed) return;
      dragging = true; sx = e.clientX; sy = e.clientY;
      img.setPointerCapture(e.pointerId);
      img.style.cursor = 'grabbing';
    });
    img.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      img.style.transform = 'translate(' + (ox + e.clientX - sx) + 'px, ' +
                            (oy + e.clientY - sy) + 'px) scale(2)';
    });
    img.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      ox += e.clientX - sx; oy += e.clientY - sy;
      img.style.cursor = 'grab';
    });
  }

  /* --------------------------------------------- scorrimento con inerzia -- */
  /* Solo con il mouse: sul touch lo scorrimento del sistema è già migliore di
     qualsiasi imitazione, e sostituirlo peggiora sempre le cose. */
  function initSmoothScroll() {
    if (reduce || isTouch) return;

    var target = window.scrollY;
    var current = window.scrollY;
    var running = false;

    function frame() {
      current += (target - current) * 0.12;
      if (Math.abs(target - current) < 0.4) {
        current = target;
        running = false;
        window.scrollTo(0, current);
        return;
      }
      window.scrollTo(0, current);
      requestAnimationFrame(frame);
    }

    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || e.deltaMode !== 0) return;
      e.preventDefault();
      var max = document.documentElement.scrollHeight - window.innerHeight;
      target = Math.max(0, Math.min(max, target + e.deltaY));
      if (!running) { running = true; requestAnimationFrame(frame); }
    }, { passive: false });

    // se qualcosa muove la pagina in altro modo (ancore, tastiera), ci riallineiamo
    window.addEventListener('scroll', function () {
      if (!running) { target = window.scrollY; current = window.scrollY; }
    }, { passive: true });
  }

  /* L'altezza dell'intestazione serve al CSS: la scena dell'hero le passa
     sotto, cosi' in cima la pagina e' tutta notte e non c'e' una fascia di
     carta fra la barra nera e la strada. */
  function misuraAltezza(header) {
    var h = Math.round(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--hh-head-h', h + 'px');
    /* Quanto occupa tutto quello che sta sopra la scena, avviso compreso.
       L'hero si infila sotto l'intestazione per essere a pieno schermo: senza
       questa seconda misura il suo primo rigo finiva sotto la barra, e su un
       telefono l'occhiello passava dietro il bottone. L'avviso non e'
       appiccicato ma alla prima schermata e' li', quindi conta. */
    var avviso = document.querySelector('.hh-announce');
    var a = avviso ? Math.round(avviso.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--hh-top-h', (h + a) + 'px');
  }

  /* --------------------------------------------------- intestazione viva -- */
  /* Si ritira mentre scendi, torna appena risali: dà spazio alla lettura e
     rende evidente che la pagina risponde. */
  function initHeader() {
    var header = document.querySelector('.hh-header');
    if (!header) return;
    /* Con le animazioni di sistema spente l'intestazione non si muove, ma deve
       comunque essere solida: senza "is-stuck" resterebbe trasparente sopra
       una pagina chiara e il testo sparirebbe. */
    if (reduce) { header.classList.add('is-stuck'); header.removeAttribute('data-theme'); misuraAltezza(header); return; }

    /* L'intestazione e' trasparente e scrive in osso SOLO quando poggia su una
       scena notturna a piena larghezza, cioe' sulla home. Sulle altre pagine
       (note legali, carrello, ricerca, indirizzo sbagliato) sotto c'e' la
       carta chiara: misurato, il nome del prodotto e le voci di menu erano
       quasi bianche su fondo chiaro e non si leggevano. Da qui in poi la barra
       parte solida ovunque tranne dove c'e' davvero una scena. */
    var scena = document.querySelector('.hh-hero--scene, .hh-final--scene');
    var poggiaSuScena = !!scena && scena.getBoundingClientRect().top < window.innerHeight * 0.5;
    if (!poggiaSuScena) {
      header.classList.add('is-stuck');
      header.removeAttribute('data-theme');
      misuraAltezza(header);
      window.addEventListener('resize', function () { misuraAltezza(header); }, { passive: true });
      return;
    }
    header.setAttribute('data-theme', 'dark');
    misuraAltezza(header);
    window.addEventListener('resize', function () { misuraAltezza(header); }, { passive: true });
    var last = window.scrollY;
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.scrollY;
      var solida = y > 8;
      header.classList.toggle('is-stuck', solida);
      /* finche' e' trasparente poggia sulla scena notturna: dichiararlo rende
         corretti sia i colori ereditati sia le verifiche di contrasto */
      if (solida) header.removeAttribute('data-theme');
      else header.setAttribute('data-theme', 'dark');
      if (y > 240 && y > last + 6) header.classList.add('is-hidden');
      else if (y < last - 6 || y < 240) header.classList.remove('is-hidden');
      last = y;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  /* ------------------------------------------------ qualcuno ti ha notato -- */
  /* Dopo un po' che sei sulla pagina, in basso compare una figura che ti
     guarda. Non salta addosso, non fa rumore, non blocca niente: resta lì
     qualche secondo e se ne va. Una volta sola per visita. */
  function initGuest() {
    try { if (sessionStorage.getItem('hh-guest')) return; } catch (e) {}

    var section = document.querySelector('[data-hh-guest]');
    if (!section) return;
    var src = section.getAttribute('data-hh-guest');
    var line = section.getAttribute('data-hh-guest-line') || '';

    var shown = false;

    /* Dove comparirebbe il Guest c'e' qualcosa da toccare?
       Misurato il 2026-09-11 sul telefono: la figura si sedeva esattamente
       sopra "Get The Hollow Harvest" della chiusura e per sette secondi il
       bottone che incassa era inservibile. Una figura d'atmosfera non puo'
       mai coprire un comando: se il posto e' occupato, si rimanda. */
    function postoLibero() {
      var stretto = window.innerWidth <= 720;
      var alto = 130;
      var basso = window.innerHeight - (stretto ? 84 : 24);
      var zona = { top: basso - alto, bottom: basso, left: stretto ? 16 : 24, right: stretto ? window.innerWidth - 16 : 460 };
      var comandi = document.querySelectorAll('.hh-btn, a[href], button, input, summary');
      for (var i = 0; i < comandi.length; i++) {
        var el = comandi[i];
        if (el.closest('.hh-buybar, .hh-header, .hh-guest')) continue;   /* la barra sta sotto, l'intestazione sopra */
        var r = el.getBoundingClientRect();
        if (r.width < 4 || r.height < 4) continue;
        if (r.bottom < zona.top || r.top > zona.bottom || r.right < zona.left || r.left > zona.right) continue;
        return false;
      }
      return true;
    }

    function show() {
      if (shown) return;
      if (!postoLibero()) return;   /* non si consuma il turno: riprova al prossimo scorrimento */
      shown = true;
      try { sessionStorage.setItem('hh-guest', '1'); } catch (e) {}

      var el = document.createElement('aside');
      el.className = 'hh-guest';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<img src="' + src + '" alt=""><p>' + line + '</p>' +
        '<span class="hh-guest__x" aria-hidden="true">&#215;</span>';
      document.body.appendChild(el);

      requestAnimationFrame(function () { el.classList.add('is-in'); });

      setTimeout(function () {
        el.classList.remove('is-in');
        setTimeout(function () { el.remove(); }, 900);
      }, 7000);

      el.addEventListener('click', function () {
        el.classList.remove('is-in');
        setTimeout(function () { el.remove(); }, 900);
      });
    }

    // quando sei sceso oltre metà pagina e hai passato un po' di tempo qui
    var t0 = Date.now();
    function check() {
      var deep = window.scrollY > (document.documentElement.scrollHeight - window.innerHeight) * 0.45;
      if (deep && Date.now() - t0 > 25000) {
        show();
        if (shown) window.removeEventListener('scroll', check);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
  }

  /* --------------------------------------------- barra d'acquisto mobile -- */
  /* Sul telefono il bottone dell'hero sparisce dopo due schermate e per
     comprare bisogna scorrere fino in fondo. Questa barra compare quando l'hero
     esce di scena e sparisce quando arrivi alla sezione del prezzo. */
  function initBuyBar() {
    var pricing = document.querySelector('#pricing, .hh-buy');
    var hero = document.querySelector('.hh-hero');
    if (!pricing || !hero) return;

    /* L'etichetta viene dall'intestazione, non dalla sezione del prezzo:
       quella del prezzo e' lunga ("Get The Hollow Harvest") e su uno schermo
       da 390 pixel spingeva il bottone fuori dallo schermo, misurato. Quella
       dell'intestazione e' gia' scritta corta perche' deve stare in una barra. */
    var ctaTesta = document.querySelector('.hh-header .hh-btn--primary, .hh-header__cta');
    var ctaPrezzo = pricing.querySelector('.hh-btn--primary');
    var label = (ctaTesta && ctaTesta.textContent.trim()) ||
                (ctaPrezzo && ctaPrezzo.textContent.trim()) ||
                'Get the bundle';

    var bar = document.createElement('div');
    bar.className = 'hh-buybar';
    bar.innerHTML = '<span class="hh-buybar__name">The Hollow Harvest</span>' +
      '<a class="hh-btn hh-btn--primary hh-buybar__cta" href="#' + (pricing.id || 'pricing') + '">' + label + '</a>';
    document.body.appendChild(bar);

    var ticking = false;
    function update() {
      ticking = false;
      var heroOut = hero.getBoundingClientRect().bottom < 0;
      var priceRect = pricing.getBoundingClientRect();
      var priceVisible = priceRect.top < window.innerHeight && priceRect.bottom > 0;
      bar.classList.toggle('is-in', heroOut && !priceVisible);
      /* Chi ha gia' visto il prezzo non deve tornare su per comprare: da quel
         momento la barra porta dritta al pagamento, e prende l'indirizzo dal
         bottone d'acquisto vero, cosi' se un giorno cambia la variante la barra
         la segue da sola. Prima del prezzo resta un salto alla sezione: mandare
         al checkout chi non sa ancora quanto costa e' una porta in faccia. */
      if (priceVisible && !bar.dataset.hhDiretta) {
        var acquisto = document.querySelector('.hh-buy__cta[href^="/cart/"]');
        if (acquisto) {
          var cta = bar.querySelector('.hh-buybar__cta');
          if (cta) { cta.setAttribute('href', acquisto.getAttribute('href')); }
          bar.dataset.hhDiretta = '1';
        }
      }
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    update();
  }


  function init() {
    initCurtain();
    initHeader();
    initGuest();
    initBuyBar();
    initSplitTitles();
    initTrackScroll();
    initLightbox();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
